<header-title [model]="headerTitle"></header-title>
<section role="main" class="content-body tab-menu-opened" *ngIf="headerTitle">
    <div class="row">
        <div class="col">
            <section class="card">
                <header class="card-header">
                    <h2 class="card-title">{{ headerTitle.title }}</h2>
                </header>
                <div class="card-body py-5">
                    <form *ngIf="companyAuditDetailsFormGroup" (submit)="updateCompanyAudit()" [formGroup]="companyAuditDetailsFormGroup">
                        <section class="panel">
                            <div class="panel-body">
                                <error-message [errors]="errors"></error-message>

                                <div class="row mt-3">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class="control-label">
                                                Title
                                            </label>
                                            <h4 *ngIf="!isEditMode">{{companyAuditDetailsFormGroup.value.title}}</h4>
                                            <input *ngIf="isEditMode" type="text" class="form-control" formControlName="title" />
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <label class="control-label">Audit</label>
                                        <h4 *ngIf="!isEditMode">{{companyAuditDetailsFormGroup.value.title}}</h4>
                                        <select *ngIf="isEditMode" name="auditTypeId" class="form-control" formControlName="auditId">
                                            <option [value]="''">--Select Audit--</option>
                                            <option *ngFor="let audit of audits" value="{{audit.id}}">{{audit.name}}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row mt-3">
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class="control-label">Start Date</label>
                                            <h4 *ngIf="!isEditMode">{{companyAuditDetailsFormGroup.value.startDate}}</h4>
                                            <input id="startDate"
                                                   name="startDate"
                                                   class="form-control"
                                                   formControlName="startDate"
                                                   type="text"
                                                   placeholder="DD/MM/YYYY"
                                                   bsDatepicker
                                                   [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group">
                                            <label class="control-label">End Date</label>
                                            <h4 *ngIf="!isEditMode">{{companyAuditDetailsFormGroup.value.endDate}}</h4>
                                            <input id="endDate"
                                                   name="endDate"
                                                   class="form-control"
                                                   formControlName="endDate"
                                                   type="text"
                                                   placeholder="DD/MM/YYYY"
                                                   bsDatepicker
                                                   [bsConfig]="{ isAnimated: true, containerClass: 'theme-default', dateInputFormat : 'DD/MM/YYYY' }">
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <footer class="panel-footer mt-3">
                                <div class="row">
                                    <div class="col-sm-9 col-sm-offset-3">
                                        <button class="btn btn-primary" type="button" (click)="toggleEditMode()" *ngIf=" !isEditMode">Edit</button>
                                        <button class="btn btn-info ml-1" type="button" (click)="onBack()" *ngIf="!isEditMode">Back</button>
                                        <button class="btn btn-danger mr-1" type="button" (click)="toggleEditMode()" *ngIf="isEditMode">Cancel</button>
                                        <button class="btn btn-success" type="submit" *ngIf="isEditMode">Save</button>
                                    </div>
                                </div>
                            </footer>
                        </section>
                    </form>
                </div>
            </section>
        </div>
    </div>
</section>

<app-alert-message (successClicked)="successClicked($event)"
                   (onHide)="onHide($event)"
                   [title]="'Success'"
                   [message]="'Updated the company!'">
</app-alert-message>
